import CareCuesGroup from '@/modules/CareCues/CareCuesGroup';
import CareCuesEmpty from '@/modules/CareCues/CareCuesEmpty';
import styles from './CareCues.module.scss';
import {
  CareCuesGroupItem as CareCuesGroupItemInterface,
  CareCuesInterface,
  dismissCareCueItemRequested,
  selectCareCues,
  selectIsCareCuesLoading,
  selectIsEdEnabled,
  selectSelectedVisit,
  useAppDispatch,
  useAppSelector,
} from '@ax/redux-store';
import { useMemo } from 'react';
import { Loader } from '@ax/ui';
import { NOTE_STATUS, REMINDER_GROUP_TYPE } from '@ax/constants';

const CareCues = () => {
  const dispatch = useAppDispatch();
  const { uuid: noteId, noteStatus } = useAppSelector(selectSelectedVisit) || {};

  const careCues = useAppSelector(selectCareCues);
  const loading = useAppSelector(selectIsCareCuesLoading);
  const isEdEnabled = useAppSelector(selectIsEdEnabled);
  const isUploaded = useMemo(
    () =>
      noteStatus === NOTE_STATUS.NOTE_UPLOADED_TO_MDS ||
      noteStatus === NOTE_STATUS.NOTE_UPLOADED_TO_EHR,
    [noteStatus],
  );

  const handleOnCareCuesGroupItemDismissed = (
    item: CareCuesGroupItemInterface,
    group: CareCuesInterface,
  ) => {
    dispatch(dismissCareCueItemRequested({ item, group, noteId }));
  };

  if (loading) {
    return (
      <div className={styles.loading_indicator}>
        <Loader color="#fff" />
      </div>
    );
  }

  if (!noteId || !careCues || careCues.length === 0) {
    return <CareCuesEmpty />;
  }

  return (
    <div className={styles.care_cues_list}>
      {careCues.map((group) => {
        const isReadOnly =
          group.type === REMINDER_GROUP_TYPE.CHECK_BOX ? !isEdEnabled && isUploaded : isUploaded;

        return (
          <CareCuesGroup
            key={group.id}
            noteId={noteId}
            group={group}
            onCareCuesGroupItemDismissed={handleOnCareCuesGroupItemDismissed}
            readonly={isReadOnly}
          />
        );
      })}
    </div>
  );
};

export default CareCues;
